import { gql } from '@apollo/client';

const INSERT_LOGS_ABANDONED_CHECKOUTS = gql`
  mutation InsertLogsAbandonedCheckouts(
    $customer_name: String!
    $email: String!
    $phone: String!
    $tour: String!
    $tour_id: String!
    $tour_date: String!
    $pax: Int!
    $units: jsonb!
    $availability_id: String
  ) {
    insert_logs_abandoned_checkouts(
      objects: {
        customer_name: $customer_name
        email: $email
        phone: $phone
        tour: $tour
        tour_id: $tour_id
        tour_date: $tour_date
        pax: $pax
        units: $units
        availability_id: $availability_id
      }
    ) {
      returning {
        id
      }
    }
  }
`;
export const INSERT_TOP_TIP = gql`
  mutation InsertTopTip($text: String!, $id: Int!) {
    insert_strapi_top_tips(objects: { text: $text, attraction: $id }) {
      returning {
        id
        text
      }
    }
  }
`;
export const FETCH_TOP_TIPS = gql`
  query fetchTopTips($slug: String!) {
    strapi_Attraction(where: { slug: { _eq: $slug } }) {
      top_tips(order_by: { id: desc }) {
        id
        text
        dislikes
        likes
      }
    }
  }
`;

export const UPDATE_TOP_TIP = gql`
  mutation UpdateTopTipLikesAndDislikes($id: Int, $likes: Int, $dislikes: Int) {
    update_strapi_top_tips(
      where: { id: { _eq: $id } }
      _set: { likes: $likes, dislikes: $dislikes }
    ) {
      returning {
        id
        text
        likes
        dislikes
      }
    }
  }
`;

export default INSERT_LOGS_ABANDONED_CHECKOUTS;
